import React, { useState, useContext } from 'react';
import {
  Row, Col,
  Divider,
  Button,
  Form, Input, Select, InputNumber,
  Space,
  Checkbox
} from 'antd';
import {
  CloseOutlined,
  CheckOutlined
} from '@ant-design/icons';
import { MasterContext } from '../../App';
import './style';

export default React.forwardRef((props, ref) => {
  const { mode, supplier, onCloseCallback, onSaveCallback } = props;
  const { country, currency, user, currentUser, authorities } = useContext(MasterContext);
  const [form] = Form.useForm();
  const [isReadonly, setReadonly] = useState(mode === 'edit');

  const [selectedCurrencyId, setSelectedCurrencyId] = useState(supplier && supplier.currency_id);
  const [name, setName] = useState(supplier && supplier.name);
  const [countryId, setCountryId] = useState(supplier && supplier.country_id);
  const [address, setAddress] = useState(supplier && supplier.address);
  const [contact, setContact] = useState(supplier && supplier.contact);
  const [tel, setTel] = useState(supplier && supplier.tel);
  const [abbr, setAbbr] = useState(supplier && supplier.abbr);
  const [email, setEmail] = useState(supplier && supplier.email);
  const [remark, setRemark] = useState((supplier && supplier.remark) || '-');
  const [isOpenPrice, setOpenPrice] = useState(supplier ? supplier.is_open_price : true);
  const [palletMax, setPalletMax] = useState(supplier ? supplier.pallet_max : 1100);
  const [palletRatio, setPalletRatio] = useState(supplier ? supplier.pallet_ratio : 1.1);
  const [palletFlag, setPalletFlag] = useState(supplier ? supplier.pallet_flag : '-');

  const onClose = async () => {
    try {
      if (onCloseCallback) {
        onCloseCallback();
      }
    } catch (errInfo) {
      console.log('Error:', errInfo);
    }
  }
  const onSave = async () => {
    const values = await form.validateFields();
    if (onSaveCallback) {
      onSaveCallback(values);
    }
    setReadonly(true);
  }

  const onChangeAbbr = (value) => {
    const upper = value.toUpperCase();
    setAbbr(upper);
  }
  const initValue = [
    { name: ['id'], value: supplier && supplier.id },
    { name: ['name'], value: name },
    { name: ['currency_id'], value: selectedCurrencyId },
    { name: ['country_id'], value: countryId },
    { name: ['contact'], value: contact },
    { name: ['email'], value: email },
    { name: ['address'], value: address },
    { name: ['abbr'], value: abbr },
    { name: ['tel'], value: tel },
    { name: ['remark'], value: remark },
    { name: ['is_open_price'], value: isOpenPrice },
    { name: ['pallet_max'], value: palletMax },
    { name: ['pallet_ratio'], value: palletRatio },
    { name: ['pallet_flag'], value: palletFlag },
  ];

  return (
    <Form style={{ padding: '1rem' }} form={form} preserve={false} onFinish={onSave} fields={initValue}>
      <Row>
        <Col span={12}>
          <Form.Item hidden="true" name="id">
            <Input />
          </Form.Item>
          <Form.Item label="供应商名" name="name" rules={[{ required: true, message: '请输入供应商名称!' }]}>
            <Input
              autocomplete="off"
              disabled={isReadonly}
              onChange={(e) => setName(e.target.value)}
              size="small"
              placeholder="请输入供应商名称"
            />
          </Form.Item>
          <Form.Item label="结算货币" name="currency_id" rules={[{ required: true, message: '请选择结算货币!' }]}                            >
            <Select onChange={(value) => setSelectedCurrencyId(value)} disabled={isReadonly} placeholder="请选择结算货币" size="small" style={{ width: '100%' }} >
              {currency.map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {`(${item.name})`}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="联系人　" name="contact" rules={[{ required: true, message: '请输入联系人!' }]}                            >
            <Input
              autocomplete="off"
              disabled={isReadonly}
              onChange={(e) => setContact(e.target.value)}
              placeholder="请输入联系人"
              size="small" />
          </Form.Item>
          <Form.Item label="电　　话" name="tel" rules={[{ required: true, message: '请输入电话!' }]}                            >
            <Input
              autocomplete="off"
              disabled={isReadonly}
              onChange={(e) => setTel(e.target.value)}
              size="small"
              placeholder="请输入电话"
            />
          </Form.Item>

        </Col>
        <Col span={12}>
          <Form.Item label="拼音缩写" name="abbr" rules={[{ required: true, message: '请输入拼音缩写!' }]}                            >
            <Input
              autocomplete="off"
              disabled={isReadonly}
              onChange={(e) => onChangeAbbr(e.target.value)}
              size="small"
              placeholder="请输入拼音缩写"
            />
          </Form.Item>
          <Form.Item label="所属国家" name="country_id" rules={[{ required: true, message: '请选择所属国家!' }]}>
            <Select
              disabled={isReadonly}
              onChange={(value) => setCountryId(value)}
              size="small"
              showSearch="true"
              placeholder="请选择所属国家"
            >
              {country.map(item => (
                <Select.Option key={item.id} value={item.id}>
                  {item.name_en}-{item.name_cn}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="详细地址" name="address" rules={[{ required: true, message: '请输入供应商详细地址!' }]}>
            <Input.TextArea
              disabled={isReadonly}
              onChange={(e) => setAddress(e.target.value)}
              size="small"
              style={{ margin: '0.3rem 0 0.7rem 0' }}
              placeholder="请输入详细地址"
              autoSize={{ minRows: 2, maxRows: 2 }}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="邮　　箱" name="email" rules={[{ required: true, message: '请输入邮箱!' }]}                            >
            <Input
              autocomplete="off"
              disabled={isReadonly}
              onChange={(e) => setEmail(e.target.value)}
              size="small"
              placeholder="请输入邮箱"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="备　　注" name="remark" rules={[{ required: true, message: '请输入备注!' }]}>
            <Input
              disabled={isReadonly}
              onChange={(e) => setRemark(e.target.value)}
              size="small"
              placeholder="请输入备注"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="托盘限重" name="pallet_max" rules={[{ required: true, message: '请输入托盘限重!' }]}                            >
            <InputNumber
              style={{width: '100%' }}
              disabled={isReadonly}
              onChange={setPalletMax}
              min={1}
              keyboard={false}
              size="small"
              placeholder="请输入托盘允许最大重量(KG)"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="托盘箱比" name="pallet_ratio" rules={[{ required: true, message: '请输入托盘箱比!' }]}>
            <InputNumber
              style={{ width: '100%' }}
              min={0.01}
              keyboard={false}
              disabled={isReadonly}
              onChange={setPalletRatio}
              size="small"
              placeholder="请输入托盘最大箱比"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
      <Col span={12}>
          <Form.Item label="托盘标识" name="pallet_flag" rules={[{ required: true, message: '请输入托盘标识!' }]}>
            <Input
              disabled={isReadonly}
              onChange={(e) => setPalletFlag(e.target.value)}
              size="small"
              placeholder="请输入托盘最标识"
            />
          </Form.Item>
        </Col>
      </Row>
      <Divider style={{ margin: '0.5rem 0' }} />
      <Row>
        <Col span={12}>
          <Form.Item label={<strong>是否公开价格</strong>} valuePropName="checked" name="is_open_price">
            <Checkbox onChange={(e) => setOpenPrice(e.target.checked)} disabled={isReadonly} />
          </Form.Item>
        </Col>
      </Row>
      <Divider style={{ margin: '0.5rem 0' }} />
      <div className="page-footer">
        <div></div>
        <Space size="large">
          {onClose && <Button onClick={onClose} icon={<CloseOutlined />}>关 闭</Button>}
          {
            !isReadonly && <div style={{ display: 'flex', alignItems: 'center' }}>
              {(authorities.find(x => x === 'create_supplier' || x === 'edit_supplier') || currentUser.category_id === 1) && <Button htmlType="submit" type="primary" icon={<CheckOutlined />}>保 存</Button>}
            </div>
          }
          {
            isReadonly && <div style={{ display: 'flex', alignItems: 'center' }}>
              {(authorities.find(x => x === 'create_supplier' || x === 'edit_supplier') || currentUser.category_id === 1) && <Button onClick={() => setReadonly(false)} type="primary" icon={<CheckOutlined />}>编 辑</Button>}
            </div>
          }
        </Space>
      </div>
    </Form>
  )
});
